var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{key:"modal",attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask modal-base"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container modal-center"},[_vm._t("header"),_vm._v(" "),_c('br'),_vm._v(" "),_vm._t("body")],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0237d4ef","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/packs/shared/components/modal_base.vue
// module id = 330
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 13 16 17 75 85 93 123 148 167 168 169 281 350